import cx from "classnames";
import React from "react";
import { dataTestIds } from "data-testids";

import "./BreakdownMessage.scss";

export interface IBreakdownMessageProps {
  keepFormatting?: boolean;
  isPrintView?: boolean;
}

const BreakdownMessage: React.FC<
  React.PropsWithChildren<IBreakdownMessageProps>
> = (props) => (
  <div
    className={cx("c-breakdown-message", {
      "c-breakdown-message--keep-formatting": props.keepFormatting,
      "c-breakdown-message--print": props.isPrintView,
    })}
    data-testid={dataTestIds.nuJobsApp["Components.Breakdown.breakdownMessage"]}
  >
    {props.children}
  </div>
);

export default BreakdownMessage;
